import storage from "./storage";

/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace SponsorStorageService
 */
"use strict";
let STORAGE_KEY = storage.metadata.SPONSOR;

// ---------------------------------------------
//
//            Define public methods
//
// ---------------------------------------------
var publicMethods = {
    clearSponsor: function () {
        publicMethods.setSponsor(null);
    },
    getSponsor: function () {
        return storage.getItem(STORAGE_KEY);
    },
    setSponsor: function (sponsor) {
        if (sponsor == null || typeof (sponsor) == 'undefined') {
            storage.removeItem(STORAGE_KEY);
        } else {
            storage.setItem(STORAGE_KEY, sponsor);
        }
    }
};

export default publicMethods;
